import { useState, useEffect, useContext } from "react";
import { Census_func } from "../../../api/devices/census/census_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Input, Tooltip, ButtonProps } from "@fluentui/react-components";
import { PulseSquare20Regular, AppsAddIn20Regular, BoxCheckmark20Regular, UninstallApp20Regular, CheckboxCheckedSync20Regular, SquareHintApps20Regular, ShieldLock20Regular, BookTemplate20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, SlideEraser20Regular, Copy20Regular, AddSquare20Regular, Dismiss16Regular, ArrowMaximize20Regular, DismissSquare24Filled, FilterAdd20Filled } from "@fluentui/react-icons";
import { SearchBox } from "@fluentui/react-search-preview";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { Resize } from "../../../components/textarea/textarea.component";
import { Checked } from "../../../components/switch/switch.component";
import { CheckBox } from "../../../components/checkbox/checkbox_component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { fullscreenIcon, primaryIcon, secondaryIcon, exitIcon, lightTheme, overflowDivider, buttonContent, dividerWidthStyle, heightResponsive, DynamicBoxingCSS, parentHome, wraperStyle, SubSectionResponsive, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import DialogBox from "../../../components/dialog/dialog.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { SkeletonContent } from "../../../components/skeleton/skeletonContent";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { ManageAppPages } from "../../../components/side_menu/InlineSidenav";

const handleExportCSV = () => {
  // Programmatically trigger the CSV export link
  const csvExportLink = document.getElementById('csv-export-link');
  if (csvExportLink) {
    csvExportLink.click();
  }
};

export const Discoveredapps = () => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  const handle = useFullScreenHandle();
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [isdeletedisabled, setDeleteDisabled] = useState(false);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [isfilter, setIsFilter]: any = useState(false);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);

  // const [permissions, setPermissions] = useState(['']);

  const { permissions } = usePermissionStore();
  console.log("checking the permissions------>", permissions)

  const [refreshing, setRefreshing] = useState(false);
  const handleRefresh = () => {
    setRefreshing(true);
    setRefreshToast(true);
    setLoading(true);
  };

  // const inputChange=(e:any)=>{
  //   const enteredValue =e.target.value;
  //   console.log("entered value",enteredValue)
  //   let name =e.target.name;
  //   if (name === 'filter') {
  //     setDropDownValue2(enteredValue);
  //   }
  // }
  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_-]*$/;
    const regexN = /^[0-9\.]*$/;
    if (name === 'filter' && dropDownValue1 === ("Application Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Application Version")) {
      if (regexN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Size in kb")) {
      if (regexN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
  }

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    // Check if the column is already filtered
    const columnExists = filterArray.some(filter => filter.startsWith(`${value1} :`));
    if (!columnExists) {
      const result = value1 + " : " + value2;
      setFilterArray([...filterArray, result]);
      setIsFilter(true);
      setLoading(true);
      setDropDownValue1('');
      setDropDownValue2('');
    }
  };

  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }
  const handleFilterValueSelect = (event: { target: { value: Event; }; }): void => {
    alert(event.target.value);
  }

  useEffect(() => {
    setResetDisabled(filterArray.length > 0 ? false : true);
  }, [filterArray]);
  const [response, setresponse] = useState('');
  const [isIconEnabled, setIconEnabled] = useState(false);
  const handleIconActive: any = (data: any) => {
    setIconEnabled(data.target.checked);
  }

  //data table column name code starts here
  var columns = [
    { key: "app_name", label: <Body1Strong> Application Name </Body1Strong> },
    { key: "app_ver", label: <Body1Strong> Application Version </Body1Strong> },
    //{ key: "totalDev", label: <Body1Strong> Installed Date </Body1Strong> },
    { key: "sizekb", label: <Body1Strong> Size in kb </Body1Strong> },
  ];

  //data table column name code ends here

  //filter dropdown column names starts here
  var columns1 = [
    { key: "app_name", label: <Caption1> Application Name </Caption1> },
    { key: "app_ver", label: <Caption1> Application Version </Caption1> },
    { key: "sizekb", label: <Caption1> Size in kb </Caption1> },
  ];

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>

        <Stack tokens={{ childrenGap: 10 }} horizontal>

          <StackItem><Text></Text></StackItem>
          <StackItem>
            <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={handleRefresh}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
                <StackItem> <Caption1> Refresh </Caption1> </StackItem>
              </Stack>
            </Button>

            {
              permissions.includes("all") || permissions.includes("discoverApps_ReadandExport") ? (
                <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_discoceredappslist.csv`}>
                  <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem>{loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                      <StackItem> <Caption1> Export </Caption1> </StackItem>
                    </Stack>
                  </Button>
                </CSVLink>
              ) :
                <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                  <Button shape="circular" appearance="subtle" size="small" disabled>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem> <Caption1> Export </Caption1> </StackItem>
                    </Stack>
                  </Button>
                </Tooltip>
            }

          </StackItem>
        </Stack>

        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ,
  };
  // overflow set contents code ends here
  var tempTableData: any = [];
  var menuLists: any = [];
  var tempExportData: any = [];


  //export pinotAsset data
  // useEffect(() => {
  //   const fetchData = async () => {
  //     const apiUrl = 'https://pinot-dev.nanoheal.work/sql';
  //     let sqlQuery = `SELECT
  //     t1.v_installedsoftwarenames,
  //     t1.v_version,
  //     t1.slatest
  // FROM
  //     t1_d312_installed_software t1
  // WHERE
  //     t1.dataid = 36
  //     AND t1.sitename = 'Demo_Nanoheal'
  //     AND t1.slatest = (
  //         SELECT MAX(t2.slatest)
  //         FROM t1_d312_installed_software t2
  //         WHERE t2.machine = t1.machine
  //           AND t2.v_installedsoftwarenames = t1.v_installedsoftwarenames
  //     )
  // ORDER BY
  //     t1.v_installedsoftwarenames `;

  //     // If searchVal exists, modify the SQL query to include search filter
  //     if (searchVal) {
  //       sqlQuery += ` AND v_installedsoftwarenames LIKE '%${searchVal}%'`;
  //     }
  //     sqlQuery += 'limit 1000';

  //     const requestBody = {
  //       sql: sqlQuery,
  //       trace: false,
  //       queryOptions: 'useMultistageEngine=true',
  //     };

  //     const response = await fetch(apiUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(requestBody),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`No result`);
  //     }

  //     const responseData = await response.json();

  //     const rowData = responseData != undefined && responseData?.resultTable != undefined ? responseData?.resultTable?.rows : [];

  //     const uniqueData: any = [];
  //     rowData.map((row: any) => {
  //       const isDuplicate = uniqueData.some((existingRow: any) =>
  //         JSON.stringify(existingRow) === JSON.stringify(row)
  //       );
  //       if (!isDuplicate) {
  //         uniqueData.push(row);
  //       }
  //     });

  //     uniqueData !== undefined && uniqueData !== null ? uniqueData.map((data: any, i: any) => {
  //       menuLists.push();
  //       tempExportData.push({
  //         'Application Name': data[0],
  //         'Application Version': data[2],
  //         totalDev: data[5],
  //         sizekb: data[3],
  //       });
  //     }) : (tempTableData = []);
  //     setExportData(tempExportData);
  //     setData(responseData);
  //   };
  //   fetchData();

  // }, [response, searchVal, setExportData]);


  //Pinot table data
  useEffect(() => {

    const fetchData = async () => {
      var whereCondition = '';
      // If searchVal exists, modify the SQL query to include search filter
      if (searchVal) {
        whereCondition += ` AND v_installedsoftwarenames LIKE '%${searchVal}%'`;
      } else if (isfilter) {
        console.log("filter=", filterArray);

        filterArray.map((val: any) => {
          var colName = val.split(":")[0]?.trim();
          var dropDownValue = val.split(":")[1]?.trim();

          if (colName == 'Application Name') {
            whereCondition += ` AND t1.v_installedsoftwarenames LIKE '%${dropDownValue}%'`;
          } else if (colName === 'Application Version') {
            let startOfDay = new Date(dropDownValue);
            startOfDay.setHours(0, 0, 0);

            let endOfDay = new Date(dropDownValue);
            endOfDay.setHours(23, 59, 59);

            whereCondition += ` AND t1.slatest >= '${startOfDay}' AND t1.slatest <= '${endOfDay}'`;
          } else if (colName === 'Size in kb') {
            whereCondition += ` AND t1.v_estimatedsizeinkb LIKE '%${dropDownValue}%'`;
          }
        });
      }

      try {
        const apiUrl = 'https://pinot-dev.nanoheal.work/sql';
        let sqlQuery = `SELECT t1.v_installedsoftwarenames,
  t1.v_version, t1.v_estimatedsizeinkb
FROM t1_d312_installed_software t1
WHERE t1.dataid = 36
${whereCondition}
  AND t1.sitename = 'Demo_Nanoheal'
  AND t1.slatest = (
    SELECT MAX(t2.slatest)
    FROM t1_d312_installed_software t2
    WHERE t2.machine = t1.machine
      AND t2.v_installedsoftwarenames = t1.v_installedsoftwarenames
  )
ORDER BY t1.v_installedsoftwarenames `;

        sqlQuery += 'limit 1000';

        const requestBody = {
          sql: sqlQuery,
          trace: false,
          queryOptions: 'useMultistageEngine=true',
        };

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`No result`);
        }

        const responseData = await response.json();
        const rowData = responseData.resultTable.rows;

        const uniqueCombinations = new Set();
        const uniqueData = rowData.filter((row: any) => {
          const combination = `${row[0]}_${row[2]}`;
          if (!uniqueCombinations.has(combination)) {
            uniqueCombinations.add(combination);
            return row;
          }
        });

        const startIndex = ((currentPageNo - 1) * 50);
        const endIndex = currentPageNo * 50;
        const currentPageData: any = uniqueData.slice(startIndex, endIndex);

        currentPageData.forEach((data: any, i: any) => {
          tempTableData.push({
            checkbox: "hide",
            app_name: {
              label:
                <Button
                  size="small"
                  appearance="transparent"
                  id="ButtonHover"
                  style={buttonContent}
                  onClick={() => {
                    navigate("/manage/apps/discoveredapps/discoveredapps_list")
                    localStorage.setItem(
                      'devName',
                      JSON.stringify({
                        devName: data[6],
                        appName: data[0]
                      })
                    );
                    contextValue.setSelectedRowDetails({
                      ...contextValue.selectedRowDetails,
                      name: data[6]
                    });
                  }}
                >
                  {data[0]}
                </Button>,
              id: `${i}`
            },
            app_ver: { label: <Caption1> {data[1] === "" ? "-" : data[1]}  </Caption1>, status: "" },
            sizekb: { label: <Caption1> {data[2] === "" ? "-" : data[2]} </Caption1> },
          });
        });

        setTotalRecords(uniqueData.length);
        setTotalPages(Math.ceil((uniqueData.length) / 50));
        setTableData(tempTableData);
        setData(responseData);
        setTimeout(() => {
          setLoading(false);
        }, 500);
        // setLoading(false);
        setRefreshing(false); // Reset refreshing state after data is fetched
        setRefreshToast(false);
      } catch (error) {
        setError('No results!');
        // setLoading(false);
        setTimeout(() => {
          setLoading(false);
        }, 500);
        setRefreshing(false); // Reset refreshing state in case of error
        setRefreshToast(false);

      }
    };

    fetchData();

  }, [response, searchVal, refreshing, currentPageNo, permissions, isfilter, filterArray, setExportData]);


  // if (loading) return <p>Loading... </p>;
  // if (loading) return <SkeletonContent />;
  // if (error) return <p>Error: {error}</p>;




  // data table values append code ends here
  var overLayData: any = {
    headerTitle: "Temp File Clean Up",
    size: "large",
    isTabs: true,
    tabItems: {
      Introduction:
        <>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            Introduction
          </Stack>
        </>,

      Configuration:
        <>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            Configuration
          </Stack>
        </>,
    },
  };

  //console.log("tableData.length=======??", tableData.length);
  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack horizontalAlign="start" tokens={{ childrenGap: 5 }}>
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink> 
                  <Breadcrumbs 
                          items={[
                            { name: "Manage", link: "/home" },
                            { name: "Apps", link: "#" },
                            { name: "Discover Apps", link: "#" }
                          ]} 
                  />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            <StackItem style={DynamicBoxingCSS}>
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={DynamicBoxingCSS}>
                  {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
                    <StackItem> <Text></Text> </StackItem>
                    <StackItem>
                      <Title3> Apps | Discovered Apps </Title3>
                    </StackItem>
                  </Stack> */}
                  <FluentProvider style={parentHome} theme={dashboardTheme}>
                    <Stack style={parentHome} horizontal >
                      {/* SPACING BETWEEN INLINE AND PAGE */}
                      <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={ManageAppPages("Discovered Apps")} />
                      <StackItem style={DynamicBoxingCSS}>
                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                          <StackItem>
                            <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                            <Divider />
                          </StackItem>
                          <StackItem>
                            <StackItem style={wraperStyle}>
                              <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                <StackItem>
                                  <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Application"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                  </StackItem>
                                  <StackItem>
                                    <MenuDropdown open={filterMenuOpen} btn={
                                      <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                          <FilterAdd20Filled {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)}/>
                                          <Body1> Filter </Body1>
                                        </Stack>
                                      </MenuButton>
                                    } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                      <Divider />
                                      <MenuList>
                                        <Stack tokens={{ childrenGap: 5 }}>
                                          <StackItem> <Text></Text> </StackItem>
                                          <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                          <DropdownComponent optionData={columns1} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                          {/* <DropdownComponent optionData={columns}/> */}
                                          <StackItem> <Divider /> </StackItem>
                                          <StackItem> <Caption1> Value </Caption1> </StackItem>
                                          {/* <DropdownComponent optionData={columns}  setDropDownValue = {setDropDownValue2} dropDownvalue = {dropDownValue2}/> */}
                                          {/* <Input size= 'small' onChange={inputChange} name="filter" value={dropDownValue2}/> */}
                                          {(dropDownValue1 === "Application Name") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                          {(dropDownValue1 === "Application Version") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                          {(dropDownValue1 === "Size in kb") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                          {/* <DropdownComponent optionData={columns}/> */}
                                          <StackItem> <Divider /> </StackItem>
                                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                                            <StackItem>
                                              <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                <Caption1> Apply </Caption1>
                                              </Button>
                                            </StackItem>

                                            <StackItem>
                                              <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                <Caption1> Cancel </Caption1>
                                              </Button>
                                            </StackItem>
                                          </Stack>
                                        </Stack>
                                      </MenuList>
                                    </>} />
                                  </StackItem>
                                  <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true) }}>
                                    <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                      </Stack>
                                    </Button>
                                  </StackItem>
                                </Stack>
                                {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                              </Stack>
                              <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                                <StackItem>
                                  {filterArray.length > 0 &&
                                    // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                    <Stack wrap horizontal >
                                      {filterArray.length > 0 && filterArray.map((item, index) => (
                                        <Button shape="circular" size="small">
                                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                            <StackItem>
                                              <Stack tokens={{ childrenGap: 1 }}>
                                                <StackItem><Text></Text></StackItem>
                                                <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                              </Stack>
                                            </StackItem>
                                          </Stack>
                                        </Button>
                                      ))}
                                      {/* </Stack> */}
                                    </Stack>}
                                </StackItem>

                                <StackItem disableShrink>
                                  {(tableData.length > 0 && !loading) && (
                                    totalRecords > 0 &&
                                    <Caption1>
                                      Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                    </Caption1>
                                  )}
                                </StackItem>
                              </Stack>
                            </StackItem>
                            <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                          </StackItem>
                          {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (
                            <DataTable tableData={tableData} columns={columns}></DataTable>
                          ) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                        </Stack>
                      </StackItem>
                    </Stack>
                  </FluentProvider>
                  <OverLay
                    overlayopen={overlayOpen}
                    setOverlayOpen={setOverlayOpen}
                    overlayData={overLayData}
                  />
                </Stack>
              </FluentProvider>
            </StackItem>
          </StackItem>
          <StackItem><Text></Text></StackItem>
          {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
        </Stack>
      </FullScreen>
    </>
  );
};

function fetchData() {
  throw new Error("Function not implemented.");
}
